import styled, { css } from "styled-components";
import { TypographyV2 } from "config/font";
import { ColorV2 } from "config/colors";

type ShiftBlockSize = "small" | "large" | "pill";

export const Block = styled.div<{
  $size: ShiftBlockSize;
  $backgroundColor: string;
  $textColor: string;
  $clickable: boolean;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 6px;
  background-color: ${(props) => props.$backgroundColor};
  color: ${(props) => props.$textColor};
  box-sizing: border-box;
  max-width: 100%;
  min-width: 0;
  cursor: ${(props) => (props.$clickable ? "pointer" : "default")};
  position: relative;

  &:focus-visible {
    outline: 2px solid ${(props) => props.$textColor};
    outline-offset: 2px;
  }

  ${(props) =>
    props.$clickable &&
    css`
      &:hover {
        filter: brightness(0.92);
      }
    `}

  ${(props) =>
    props.$size === "large" &&
    css`
      width: 100%;
      height: 81px;
      border-radius: 16px;
      flex-direction: column;
      padding: 8px 10px;
      overflow: visible;
    `}

  ${(props) =>
    props.$size === "small" &&
    css`
      width: 100%;
      height: 40px;
      border-radius: 16px;
      padding: 4px 10px;
      overflow: visible;
    `}

  ${(props) =>
    props.$size === "pill" &&
    css`
      width: 24px;
      height: 26px;
      border-radius: 8px;
    `}
`;

export const TimeText = styled.div`
  ${TypographyV2.b1};
`;

export const StatusText = styled.div`
  ${TypographyV2.s1};
`;

export const TooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: inherit;
  gap: 4px;
  text-align: inherit;
  width: 100%;
`;

export const TooltipDate = styled.div`
  ${TypographyV2.s1};
  opacity: 0.7;
  width: 100%;
`;

export const TooltipTime = styled.div`
  ${TypographyV2.b1};
  width: 100%;
  white-space: nowrap;
`;

export const TooltipStatus = styled.div`
  ${TypographyV2.s1};
  width: 100%;
`;

export const TooltipWorker = styled.div`
  ${TypographyV2.s1};
  width: 100%;
`;

export const ShiftTypeBadge = styled.div`
  position: absolute;
  top: -6px;
  right: -6px;
  z-index: 2;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: ${ColorV2.Blue6};
  border: 3px solid ${ColorV2.White};
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;
